import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { getIsUserImpersonating } from "@faire/help-center-utils/serialized-data/getIsUserImpersonating";
import { browserLevelLanguage } from "@faire/help-center-utils/serialized-data/getLocale";
import {
  getRetailer,
  getRetailerToken,
} from "@faire/help-center-utils/serialized-data/getRetailer";
import {
  getUser,
  getUserEmail,
  getUserToken,
} from "@faire/help-center-utils/serialized-data/getUser";
import { getTwoLetterLanguageCode } from "@faire/web--source/common/consts/THREE_TO_TWO_LETTER_LANGUAGE_CODE";

import { IChatbotMetadata } from "./types";

export const useChatbotStaticMetadata = (): IChatbotMetadata => {
  const retailer = getRetailer();
  const brand = getBrand();
  const businessName = retailer?.name ?? brand?.name;
  const brandEmail = brand?.email_address;
  const retailerEmail = retailer?.email_address;
  const firstName = getUser()?.first_name;
  const lastName = getUser()?.last_name;
  const userEmail = getUserEmail();
  const userType = getRetailerToken() ? "retailer" : "brand";
  const language = browserLevelLanguage();
  const userImpersonated = getIsUserImpersonating();
  const twoLetterLanguageCode =
    getTwoLetterLanguageCode(language)?.toLowerCase() ?? "en"; // default to en if no language is detected

  return {
    user_token: getUserToken() ?? "",
    first_name: firstName ?? "",
    last_name: lastName ?? "",
    email: userEmail,
    retailer_token: retailer?.token,
    brand_token: brand?.token,
    business_name: businessName,
    retailer_email: retailerEmail,
    brand_email: brandEmail,
    user_type: userType,
    locale: twoLetterLanguageCode,
    user_impersonated: userImpersonated,
  };
};
